import { useState, useRef, useMemo, useEffect } from "react";
import JoditEditor from "jodit-react";
import HTMLReactParser from "html-react-parser";
import { left_arrow } from "../../assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyPropertyContentsViewQuery, usePropertyContentsUpdateMutation } from "../redux/api/api";
import { configJodit } from "../redux/api/Constants";
import { toast } from "react-toastify";

const ViewPropertyContent = () => {
  const navigate = useNavigate();
  const editor = useRef([]);
  const [list, setList] = useState([]);
  const [value, setValue] = useState();
  const [description, setDescription] = useState([{ value: "" }]);
  const location = useLocation();
  const [loader, setLoader] = useState(false);

  const id = location?.state?.id;
  console.log("id", id);


  const [propertyViewApi] = useLazyPropertyContentsViewQuery();
  const [propetyListUpdate] = usePropertyContentsUpdateMutation();

  const propertyView = (id) => {
    propertyViewApi(id)
      .unwrap()
      .then((res) => {
        setList(res?.propertycontent)
        let descript = []
        if (res?.propertycontent?.[0]?.description) {
          descript.push({ value: res?.propertycontent?.[0]?.description })
        }
        if (res?.propertycontent?.[1]?.description) {
          descript.push({ value: res?.propertycontent?.[1]?.description })
        }
        if (res?.propertycontent?.[2]?.description) {
          descript.push({ value: res?.propertycontent?.[2]?.description })
        }
        if (res?.propertycontent?.[3]?.description) {
          descript.push({ value: res?.propertycontent?.[3]?.description })
        }
        if (res?.propertycontent?.[4]?.description) {
          descript.push({ value: res?.propertycontent?.[4]?.description })
        }
        setDescription(descript);
        // console.log("descript",descript)
      })
      .catch((err) => {
        console.log("err", err);
      })
  }

  const propertyContentUpdate = () => {
    const formdata = new FormData();
    formdata.append("policy_type", id)
    description?.map((item, ind) => {
      if (item?.value) {
        formdata.append(`descriptions[${ind}]`, item.value);
      }
      console.log("desc", description);
    })


    setLoader(true);

    propetyListUpdate(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.status == "success") {
          toast.success(res?.message);
          setLoader(false)
          navigate(-1);
        }
      })
      .catch((err) => {
        console.log("err", err);
      }).finally((e) => {
        setLoader(false);
      })
  }

  useEffect(() => {
    propertyView(id)
  }, []);

  const addDesc = () => {
    let temp = [...description];
    temp.push({
      value: "",
    });
    setDescription(temp);
  }

  const handleDescription = (event, ind, type) => {
    let temp = [...description];
    temp[ind][type] = event;
    setDescription(temp);
  };


  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          Masters - Property Content View
        </h2>
      </div>

      <div className="d-flex">
        <div
          className="d-flex ac-js gap-2 pointer"
          onClick={() => navigate(-1)}
        >
          <img src={left_arrow} className="leftArrow mb-3" alt="Back" />
          <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Back
          </p>
        </div>
      </div>
      <div className=" my-4">
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
          Name
        </h4>
        <input readOnly
          type="text"
          value={list?.[0]?.policy_type == 1 ? "Cancellation Policy" : list?.[0]?.policy_type == 2 ? "House Rules" : list?.[0]?.policy_type == 3 ? "Safety & Property" : list?.[0]?.policy_type == 4 ? "Description" : ""}
          className="input-pop ps-2 "
        />
      </div>
      <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
        Description
      </h4>
      {description.map((item, ind) => {
        return (
          <JoditEditor
            style={{ border: "1px solid #0C3A2D" }}
            className="input-pop w-100 mb-3"
            ref={(el) => (editor.current[ind] = el)}
            value={item?.value}
            config={configJodit}
            onBlur={(newContent) =>
              handleDescription(newContent, ind, "value")}
          />
        )
      })}

      {description.length <= 4 && (
        <div className="d-flex ac-je">
          <button onClick={() => { addDesc() }}
            className=" f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 white"
            style={{
              backgroundColor: "#6D9773",
              borderRadius: "5px",
              padding: "5px 20px",
              border: "0px",
            }}
          >
            Add
          </button>
        </div>
      )}
      <div className="d-flex ac-je mt-5">
        <button onClick={() => propertyContentUpdate()} className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ">
          {loader && (
            <div
              class="spinner-border spinner-border-sm "
              role="status"
              style={{ marginRight: "5px" }}
            ></div>
          )} Submit
        </button>
      </div>
    </div>
  );
};

export default ViewPropertyContent;
